
export interface PollVoteRequest {
  /** ID of the option to vote for */
  optionId: string;
}
